//get Trailer
export const GET_SUBTITLE = "GET_SUBTITLE";

//Insert Trailer
export const INSERT_SUBTITLE = "INSERT_SUBTITLE";

//Update Trailer
export const UPDATE_SUBTITLE = "UPDATE_SUBTITLE";

//Delete Trailer
export const DELETE_SUBTITLE = "DELETE_SUBTITLE";

//Open and Close Dialog
export const OPEN_SUBTITLE_DIALOG = "OPEN_SUBTITLE_DIALOG";
export const CLOSE_SUBTITLE_DIALOG = "CLOSE_SUBTITLE_DIALOG";

//toast
export const OPEN_SUBTITLE_TOAST = "OPEN_SUBTITLE_TOAST";
export const CLOSE_SUBTITLE_TOAST = "CLOSE_SUBTITLE_TOAST";
